import { useState } from "react";
import * as Icons from "lucide-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MigArchCredit from "./MigArchCredit";
import "./Sidebar.css";

/**
 * Sidebar built from the menu the backend returns for the current role, so
 * admin-only destinations appear only for admins.
 */

// The backend stores a lucide icon name per menu item; fall back to a generic
// icon if the name is ever wrong or the icon set changes under us.
const resolveIcon = (name) => Icons[name] || Icons.Circle;

const SECTION_LABELS = {
  main: null,
  admin: "Administration",
};

export default function Sidebar() {
  const [expanded, setExpanded] = useState(true);
  const { menu, loading } = useAuth();

  const sections = menu.reduce((acc, item) => {
    const key = item.section || "main";
    (acc[key] = acc[key] || []).push(item);
    return acc;
  }, {});

  return (
    <div className={`sidebar ${expanded ? "expanded" : "collapsed"}`}>
      <div className="sidebar-header">
        <div className="logo">
          <img
            src="/logo-jumig-store.png"
            alt="JUMIG Store"
            className="logo-image"
          />
        </div>
      </div>

      <div className="sidebar-content">
        {loading && <p className="sidebar-loading">Loading menu...</p>}

        {!loading &&
          Object.entries(sections).map(([section, items]) => (
            <div className="nav-section" key={section}>
              {expanded && SECTION_LABELS[section] && (
                <p className="nav-section-label">{SECTION_LABELS[section]}</p>
              )}
              <ul className="nav-list">
                {items.map((item) => {
                  const Icon = resolveIcon(item.icon);
                  return (
                    <li className="nav-item" key={item.menu_id}>
                      <NavLink
                        to={item.route}
                        className={({ isActive }) =>
                          `nav-link${isActive ? " active" : ""}`
                        }
                        title={expanded ? undefined : item.label}
                      >
                        <Icon size={20} strokeWidth={1.7} aria-hidden="true" />
                        {expanded && <span>{item.label}</span>}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
      </div>

      <div className="sidebar-footer">
        {expanded && <MigArchCredit className="sidebar-credit" />}
        <button
          type="button"
          className="toggle-btn"
          onClick={() => setExpanded((value) => !value)}
          aria-label={expanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          {expanded ? <ChevronLeft /> : <ChevronRight />}
        </button>
      </div>
    </div>
  );
}
